// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".receive-funds{width:calc(100vw - 32px);max-width:450px;position:relative}.receive-funds .close-dialog{position:absolute;top:8px;right:8px;cursor:pointer}.receive-funds .swap-btn{height:auto;width:auto;padding:4px}.receive-funds .address{word-break:break-all;margin-bottom:8px}.receive-funds .converted-amt{margin-top:-13px}", ""]);
// Exports
module.exports = exports;
